export const eliminarEspaciosYCamelizar = (cadena) => {
    // Elimina los espacios de la cadena y divide en palabras
    let palabras = cadena.split(' ');

    // Capitaliza la primera letra de cada palabra, excepto la primera
    for (let i = 1; i < palabras.length; i++) {
        palabras[i] = palabras[i].charAt(0).toUpperCase() + palabras[i].slice(1);
    }

    // Une las palabras y convierte a nomenclatura de camello
    let camelCase = palabras.join('');
    camelCase = camelCase.charAt(0).toLowerCase() + camelCase.slice(1);

    return camelCase;
}